import { useNavigate } from "react-router-dom";
import 'css/maintenance.css'
import { useState, useEffect } from "react";
import { Box, Button, Grid, styled } from "@mui/material";
import { FlexAlignCenter } from "app/components/FlexBox";

// styled components
const FlexBox = styled(Box)({
  display: "flex",
  alignItems: "center",
});

const JustifyBox = styled(FlexBox)({
  maxWidth: 'auto',
  flexDirection: "column",
  justifyContent: "center",
});

const IMG = styled("img")({
  width: "50%",
  marginBottom: "32px",
});

const MaintenanceRoot = styled(FlexAlignCenter)({
  width: "100%",
  height: "100vh !important",
});

const Maintenance = ({serviceName}) => {
    const navigate = useNavigate();

    const [countdownData, setCountdownData] = useState({
    seconds: 0,
    hours: 0,
    minutes: 0,
    });


    const calculateTimeLeft = () => {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + 1);
        targetDate.setHours(8, 0, 0, 0);
    
        const now = new Date().getTime();
        const difference = targetDate - now;
    
        if (difference > 0) {
          const seconds = Math.floor((difference / 1000) % 60);
          const minutes = Math.floor((difference / 1000 / 60) % 60);
          const hours = Math.floor((difference / 1000 / 60 / 60) % 24);
    
          setCountdownData({
            seconds,
            minutes,
            hours,
          });
        } else {
          // Target time has passed, set countdown to 0
          setCountdownData({
            seconds: 0,
            minutes: 0,
            hours: 0,
          });
        }
      };

    useEffect(() => {
        calculateTimeLeft(); // Initial calculation
    
        // Update the countdown every second
        const countdownInterval = setInterval(() => {
          calculateTimeLeft();
        }, 1000);
    
        // Clean up the interval on component unmount
        return () => clearInterval(countdownInterval);
      }, []);

    return (
    <MaintenanceRoot>
        <JustifyBox>
            {/* <IMG src="/assets/images/marcellus_name_logo.png" alt="" /> */}
            <div>
                <h1 className='heading'>Our {serviceName} service is Under Maintenance.</h1>
                <p className="text-size">We will back in...</p>
                <div className='countdown-wrapper'>
                    <div className='countdown-box'>
                        {countdownData.hours}
                        <span className='legend'>Hours</span>
                    </div>
                    <div className='countdown-box'>
                        {countdownData.minutes}
                        <span className='legend'>Minutes</span>
                    </div>
                    <div className='countdown-box'>
                        {countdownData.seconds}
                        <span className='legend'>Seconds</span>
                    </div>
                </div>
            </div>
        </JustifyBox>
    </MaintenanceRoot>
    );
};

export default Maintenance;
